import Layout from '@layouts/Layout';
import Post from '@screens/HelpCenter/Category/Post/Show';

import { useRouter } from 'next/router';
import React, { memo } from 'react';

export const getStaticPaths = async () => {
    let paths = [];

    try {
        const res = await fetch(`${ process.env.NEXT_PUBLIC_APP_URL }/api/v1/support-v2/posts`);
        const data = await res.json();

        paths = data.map(post => ({
            params: {
                category: post.category.slug,
                post: post.slug
            }
        }));
    } catch (e) {
        console.log(e);
    }

    return {
        paths: paths,
        fallback: 'blocking'
    };
};

export const getStaticProps = async (context) => {
    const { params } = context;

    const res = await fetch(`${ process.env.NEXT_PUBLIC_APP_URL }/api/v1/support-v2/${ params.category }/${ params.post }`);

    if(res.status !== 200)
        return { notFound: true };

    const data = await res.json();

    return {
        props: {
            post: data['post'],
            posts: data['posts']
        },

        revalidate: 60*60*24 // In seconds
    };
};

const PostPage = ({ post, posts }) => {
    const { asPath } = useRouter();

    return (
        <Layout
            title={ post?.title }
            description={ post?.description }
            useTitleTemplate={ `Traqq ${ asPath.includes('faq') ? 'FAQ' : 'Help Center' }` }
        >
            <Post
                post={ post }
                posts={ posts }
            />
        </Layout>
    );
};

export default memo(PostPage);
